import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import {
  themes,
  scrollTop,
  drawerStyle,
  tableRowSize,
  stickyHeader,
  displayFlexItem,
  StatusBadge,
} from "services/constants";
import { useSelector } from "react-redux";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { Typography, Box, Paper, Drawer } from "@mui/material";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { CustomButton } from "components/CustomComponents";
import { showToast } from "services/utils/Status";
import { NewSalaryTemplate } from "./NewSalaryTemplate";
import { ViewSalaryTemplate } from "./ViewSalaryTemplate";
import { salaryTempateHeader } from "pages/HR/Headers";
import { tooltipStyleProps } from "services/constants/Styles";
import { PeopleAlt } from "@mui/icons-material";

export const SalaryTemplate = ({ setSalaryConfigItem }) => {
  const { domain, userScreenAccess, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [salaryComponentDetails, setSalaryComponentDetails] = useState([]);
  const containerRef = useRef(null);
  const [getTemplateId, setGetTemplateId] = useState([]);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Salary Configuration",
    "Salary Component"
  );

  const {
    result: salaryTemplateData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}hrzone/salary/salary_template/salary-template-list/?company_id=${topbarCompanyId}`
  );
  const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);
  const [hanldeLoader, setHanldeLoader] = useState(false);

  const hanldeCreatePanel = () => {
    setIsCreatePanelOpen(true);
  };

  const handleViewPanel = () => {
    setIsViewPanelOpen(true);
  };

  const handleCreateClosePanel = () => {
    setIsCreatePanelOpen(false);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setSalaryComponentDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage]
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
      setHanldeLoader(false);
    }
  }, [reCallApi, topbarCompanyId]);

  const NewPayrunButton = (
    <CustomButton
      actionFuntion={() => {
        if (check_access) {
          hanldeCreatePanel();
        } else {
          showToast(
            "error",
            "Access denied: You are not authorized to create shift"
          );
        }
      }}
      actionName="New"
      typeName="button"
    />
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
      setHanldeLoader(false);
    }
  }, [reCallApi, topbarCompanyId]);

  return !hanldeLoader && loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mb: 1,
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Salary Template
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Create a predefined salary structure by grouping components.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}>
            <Mui.Tooltip
              title="Move to salary template Assignment"
              arrow
              slotProps={tooltipStyleProps}
            >
              <Mui.IconButton
                size="small"
                sx={{
                  bgcolor: themes?.whiteColor,
                  borderRadius: 1,
                  border: `1px solid ${themes?.mutedgreen}`,
                  width: 34,
                  height: 34,
                  mt: 0.5,
                }}
                onClick={() => setSalaryConfigItem("Group Salary Template")}
              >
                <PeopleAlt
                  sx={{ fontSize: 18, color: themes?.softMutedGreen }}
                />
              </Mui.IconButton>
            </Mui.Tooltip>
          </Box>
        </Box>
        <Paper sx={{ width: "100%", height: "78vh" }}>
          <CustomFilter
            title={"Salary Template Records"}
            filterHeaders={salaryTempateHeader}
            data={salaryTemplateData}
            filteredData={salaryComponentDetails}
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={check_access}
            newButtonComponent={NewPayrunButton}
          />

          <Mui.Grid sx={{ ml: 2, mr: 2 }}>
            <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
              <Mui.Table className="border">
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {salaryTempateHeader?.map((value) => (
                      <Mui.TableCell
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                      >
                        {value?.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {salaryComponentDetails?.length === 0 ? (
                    <InfoMessage dataLength={salaryTemplateData} />
                  ) : (
                    salaryComponentDetails
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((value) => (
                        <Mui.TableRow sx={tableRowSize}>
                          {salaryTempateHeader.map((head) => (
                            <Mui.TableCell
                              key={head.key}
                              onClick={() => {
                                if (check_access) {
                                  handleViewPanel();
                                  setGetTemplateId(value?.id);
                                } else {
                                  showToast(
                                    "error",
                                    "Access denied: You are not authorized to modify salary template"
                                  );
                                }
                              }}
                              sx={{
                                width: head.key === "expand" ? "20px" : "auto",
                              }}
                            >
                              {head.key === "status" ? (
                                <Mui.Box sx={displayFlexItem}>
                                  <StatusBadge
                                    color={value?.color_code}
                                    label={value?.status || "N/A"}
                                  />
                                </Mui.Box>
                              ) : (
                                value[head.key] ?? "N/A"
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
            <Box sx={{ mt: 1 }}>
              {salaryComponentDetails?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={salaryComponentDetails?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Box>
          </Mui.Grid>
        </Paper>
      </Box>
      <Drawer
        anchor="right"
        open={isCreatePanelOpen || isViewPanelOpen}
        onClose={() => {
          isCreatePanelOpen ? handleCreateClosePanel() : handleViewClosePanel();
        }}
        sx={drawerStyle}
      >
        {isCreatePanelOpen ? (
          <NewSalaryTemplate
            onClose={handleCreateClosePanel}
            reCallApi={reCallApi}
            setHanldeLoader={setHanldeLoader}
          />
        ) : (
          <ViewSalaryTemplate
            onClose={handleViewClosePanel}
            reCallApi={reCallApi}
            getTemplateId={getTemplateId}
            setHanldeLoader={setHanldeLoader}
            screenAccess={check_access}
          />
        )}
      </Drawer>
    </React.Fragment>
  );
};
